/*
 * Copyright (c) 2026, Gather
 * https://gather.life
 */

import { type SyntheticEvent, type ReactNode } from 'react';
import IconButton from '@mui/material/IconButton/IconButton';
import InputAdornment from '@mui/material/InputAdornment/InputAdornment';

import { Icon } from '@marketplace/gather-ui/components/icon';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSearchDropdown } from '../dropdown/search-dropdown.provider';

const styleRotate = { transform: 'rotate(90deg)' };

type StartAdornmentProps = {
  onBack: (inputEvent: SyntheticEvent) => void;
};

export function StartAdornment({ onBack }: StartAdornmentProps): ReactNode {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { dropdownState } = useSearchDropdown();

  if (isMobile) {
    return (
      // Mobile: always show start adornment
      <InputAdornment position='start'>
        {dropdownState === 'opened' ? (
          // Mobile active: back arrow to close dropdown
          <IconButton
            aria-label='Go back'
            color='transparent'
            edge='start'
            size='small'
            onClick={onBack}
          >
            <Icon color='primary' icon='arrowDown' sx={styleRotate} />
          </IconButton>
        ) : (
          // Mobile default: search icon
          <Icon color='primary' icon='search' />
        )}
      </InputAdornment>
    );
  }

  return dropdownState === 'closed' ? (
    // Desktop active: search icon
    <InputAdornment position='start'>
      <Icon color='secondary' icon='search' />
    </InputAdornment>
  ) : null;
}
